<template>
  <modal :show.sync="show" modalClasses="modal-hide-footer">
    <h3 slot="header" class="mb-0">Missed Payment</h3>
   <div v-if="_gAuth.isAppSas()">
    <div v-if="tableData.length > 0" class="rounded-bottom">
      <el-table
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          label="Date/Facility Type"
          min-width="210"
          width="auto"
        >
          <template slot-scope="scope">
            <p class="mb-0 top-line">{{ scope.row.missed_pay_approved_date }}</p>
            <p class="text-uppercase mb-0">{{ scope.row.missed_pay_loan_statue }}</p>
          </template>
        </el-table-column>

        <el-table-column
          prop="missed_pay_credit_limit"
          label="Limit (RM)"
          min-width="150"
          width="auto"
        >
          <template slot-scope="scope">
            <p class="top-line">{{ scope.row.missed_pay_credit_limit | moneyFormatter }}</p>
          </template>
        </el-table-column>

        <el-table-column
          prop="missed_pay_payment_history"
          label="Payment History"
          min-width="200"
          width="auto"
        >
          <template slot-scope="scope">
            <p class="top-line">{{ scope.row.missed_pay_payment_history }}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-else class="bg-light p-3 text-center rounded-bottom">
      <p class="text-xs">No Missed Payment History recorded</p>
    </div>
    </div>
      <div v-else>
         <!-- Fixed: Use normalizedLoanCommitment instead of loanCommitment directly -->
      <div v-if="hasLoanCommitmentData" class="loan-information rounded-bottom">
        <b-table-simple responsive bordered>
          <b-thead>
            <b-tr>
              <b-th rowspan="2">No.</b-th>
              <b-th rowspan="2">Date/R&R</b-th>
              <b-th rowspan="2">STS</b-th>
              <b-th rowspan="2">Capacity</b-th>
              <b-th rowspan="2">Lender<br> Type</b-th>
              <b-th rowspan="2">Facility</b-th>
              <b-th rowspan="2">Total O/S<br> Balance (RM)</b-th>
              <b-th rowspan="2">Date Balance<br> Updated</b-th>
              <b-th rowspan="2">Limit/Instl.<br> Amt. (RM)</b-th>
              <b-th rowspan="2">Prin. Rpmt.<br> Term</b-th>
              <b-th rowspan="2">Col<br> Type</b-th>
              <b-th colspan="12" class="pb-0">
                <div class="d-flex justify-content-between">
                  Conduct of Acc. for Last 12 Months
                  <small v-if="normalizedLoanCommitment[0].commitment_monthly && normalizedLoanCommitment[0].commitment_monthly.length > 0">
                    (From {{ normalizedLoanCommitment[0].commitment_monthly[0].month_position_date + ' untill ' + normalizedLoanCommitment[0].commitment_monthly[11].month_position_date }})
                  </small>
                </div>
              </b-th>
              <b-th rowspan="2">Lgl<br> Sts</b-th>
              <b-th rowspan="2">Date Sta.<br> Updated</b-th>
            </b-tr>
            <b-tr>
              <b-th v-for="(month, index) in normalizedLoanCommitment[0].commitment_monthly" :key="month.month_id" class="pt-0 pb-1">
                {{ monthAbbreviation(month.month_month) + (index === 0 || index === 11 ? ' `' + month.month_year.toString().slice(-2) : '') }}
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-for="(item, index) in normalizedLoanCommitment" :key="item.commitment_id || index" class="text-center">
            <b-tr>
              <b-td>{{ index + 1 }}</b-td>
              <b-td>{{ item.commitment_approved_date || '-' }}</b-td>
              <b-td>{{ item.commitment_status || '-' }}</b-td>
              <b-td>{{ item.commitment_capacity || '-' }}</b-td>
              <b-td>{{ item.commitment_lender_type || '-' }}</b-td>
              <b-td>{{ item.commitment_loan_statue || '-' }}</b-td>
              <b-td>{{ formatOutstanding(item.commitment_current_outstanding) }}</b-td>
              <b-td>{{ item.commitment_date_balance_updated || '-' }}</b-td>
              <b-td>{{ item.commitment_credit_limit | moneyFormatter }}</b-td>
              <b-td>{{ item.commitment_repay_term || '-' }}</b-td>
              <b-td>{{ item.commitment_col_type || '-' }}</b-td>
              <b-td v-for="conduct in item.commitment_monthly" :key="conduct.month_id" :class="{'akpk-arrears': conduct.month_inst_arrears !== '0' && conduct.month_inst_arrears !== ''}">
                {{ conduct.month_inst_arrears || '' }}
              </b-td>
              <b-td>{{ item.commitment_legal_status || '-' }}</b-td>
              <b-td>{{ item.commitment_legal_date || '-' }}</b-td>
            </b-tr>
            <b-tr v-for="sub_item in item.commitment_sub_items || []" :key="sub_item.commitment_id">
              <b-td></b-td>
              <b-td>{{ sub_item.commitment_approved_date === item.commitment_approved_date ? '' : (sub_item.commitment_approved_date || '-') }}</b-td>
              <b-td>{{ sub_item.commitment_status === item.commitment_status ? '' : (sub_item.commitment_status || '-') }}</b-td>
              <b-td>{{ sub_item.commitment_capacity === item.commitment_capacity ? '' : (sub_item.commitment_capacity || '-') }}</b-td>
              <b-td>{{ sub_item.commitment_lender_type === item.commitment_lender_type ? '' : (sub_item.commitment_lender_type || '-') }}</b-td>
              <b-td>{{ sub_item.commitment_loan_statue === item.commitment_loan_statue ? '' : (sub_item.commitment_loan_statue || '-') }}</b-td>
              <b-td>{{ formatOutstanding(sub_item.commitment_current_outstanding) }}</b-td>
              <b-td>{{ sub_item.commitment_date_balance_updated === item.commitment_date_balance_updated ? '' : (sub_item.commitment_date_balance_updated || '-') }}</b-td>
              <b-td>{{ sub_item.commitment_current_installment | moneyFormatter }}</b-td>
              <b-td>{{ sub_item.commitment_repay_term === item.commitment_repay_term ? '' : (sub_item.commitment_repay_term || '-') }}</b-td>
              <b-td>{{ sub_item.commitment_col_type === item.commitment_col_type ? '' : (sub_item.commitment_col_type || '-') }}</b-td>
              <b-td v-for="conduct in sub_item.commitment_monthly || []" :key="conduct.month_id" :class="{'akpk-arrears': conduct.month_inst_arrears !== '0' && conduct.month_inst_arrears !== ''}">
                {{ conduct.month_inst_arrears || '' }}
              </b-td>
              <b-td>{{ sub_item.commitment_legal_status === item.commitment_legal_status ? '' : (sub_item.commitment_legal_status || '-') }}</b-td>
              <b-td>{{ sub_item.commitment_legal_date === item.commitment_legal_date ? '' : (sub_item.commitment_legal_date || '-') }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      
      <!-- Empty State: show full table with placeholders -->
      <div v-else>
        <b-table-simple responsive bordered>
          <b-thead>
            <b-tr>
              <b-th rowspan="2">No.</b-th>
              <b-th rowspan="2">Date/R&R</b-th>
              <b-th rowspan="2">STS</b-th>
              <b-th rowspan="2">Capacity</b-th>
              <b-th rowspan="2">Lender<br> Type</b-th>
              <b-th rowspan="2">Facility</b-th>
              <b-th rowspan="2">Total O/S<br> Balance (RM)</b-th>
              <b-th rowspan="2">Date Balance<br> Updated</b-th>
              <b-th rowspan="2">Limit/Instl.<br> Amt. (RM)</b-th>
              <b-th rowspan="2">Prin. Rpmt.<br> Term</b-th>
              <b-th rowspan="2">Col<br> Type</b-th>
              <b-th colspan="12" class="pb-0">
                <div class="d-flex justify-content-between">
                  Conduct of Acc. for Last 12 Months
                  <small v-if="headerMonths && headerMonths.length > 0">
                    (From {{ headerMonths[0].month_position_date + ' untill ' + headerMonths[11].month_position_date }})
                  </small>
                </div>
              </b-th>
              <b-th rowspan="2">Lgl<br> Sts</b-th>
              <b-th rowspan="2">Date Sta.<br> Updated</b-th>
            </b-tr>
            <b-tr>
              <b-th v-for="(month, index) in headerMonths" :key="month.month_id || index" class="pt-0 pb-1">{{ monthAbbreviation(month.month_month) + (index === 0 || index === 11 ? ' `' + (month.month_year ? month.month_year.toString().slice(-2) : '') : '') }}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td>-</b-td>
              <b-td>-</b-td>
              <b-td>-</b-td>
              <b-td>-</b-td>
              <b-td>-</b-td>
              <b-td>-</b-td>
              <b-td>-</b-td>
              <b-td>-</b-td>
              <b-td>-</b-td>
              <b-td>-</b-td>
              <b-td>-</b-td>
              <b-td v-for="(month, index) in headerMonths" :key="month.month_id || index">-</b-td>
              <b-td>-</b-td>
              <b-td>-</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import { Table, TableColumn } from "element-ui";

export default {
  name: "MissedPaymentModal",
  props: {
    missedPaymentHistory: {
      type: Array,
      default: () => []
    },
    loanCommitment: {
      type: [Array, Object],
      default: () => []
    },
    show_missed_pay_full_view: Boolean
  },
  components: {
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      tableData: []
    };
  },
  computed: {
    show: {
      get() {
        return this.show_missed_pay_full_view;
      },
      set(value) {
        this.$emit("update:show_missed_pay_full_view", value);
      }
    },
    
    // Normalize loanCommitment to always be an array
    hasLoanCommitmentData() {
      if (Array.isArray(this.loanCommitment)) {
        return this.loanCommitment.length > 0;
      } else if (this.loanCommitment && typeof this.loanCommitment === 'object') {
        // Check if it's a non-empty object
        return Object.keys(this.loanCommitment).length > 0;
      }
      return false;
    },
    
    normalizedLoanCommitment() {
      if (Array.isArray(this.loanCommitment)) {
        return this.loanCommitment;
      } else if (this.loanCommitment && typeof this.loanCommitment === 'object') {
        // If it's a single object, wrap it in an array
        return [this.loanCommitment];
      }
      return [];
    },
    headerMonths() {
      // Use normalizedLoanCommitment[0].commitment_monthly when available, otherwise generate 12 placeholder months
      if (this.normalizedLoanCommitment && this.normalizedLoanCommitment.length > 0 && this.normalizedLoanCommitment[0].commitment_monthly && this.normalizedLoanCommitment[0].commitment_monthly.length === 12) {
        return this.normalizedLoanCommitment[0].commitment_monthly;
      }
      const now = new Date();
      const year = now.getFullYear();
      return Array.from({ length: 12 }, (v, i) => ({ month_month: i + 1, month_year: year, month_position_date: '-' }));
    }
  },
  watch: {
    missedPaymentHistory: {
      immediate: true,
      handler(val) {
        this.tableData = val && val.length > 0 ? val : [];
      }
    }
  },
  methods: {
    monthAbbreviation(month) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return months[month - 1] || month;
    },
    
    formatOutstanding(value) {
      if (!value || value === '0.00') return '';
      return parseFloat(value).toLocaleString(undefined, { minimumFractionDigits: 2 });
    }
  },
  // mounted() {
  //   console.log('[Missed Payment] mounted - loanCommitment:', this.loanCommitment);
  //   console.log('[Missed Payment] normalizedLoanCommitment:', this.normalizedLoanCommitment);
  //   console.log('[Missed Payment] hasLoanCommitmentData:', this.hasLoanCommitmentData);
  //   console.log('[Missed Payment] loanCommitment type:', typeof this.loanCommitment);
  // }
};
</script>